// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-contact-information__emails,.settings-contact-information__phone_numbers{min-height:75px}", ""]);
// Exports
module.exports = exports;
